module.exports = __webpack_public_path__ + "static/media/webview_slider_img1.786b9307.png";